import { Delivery, StandardCheckout } from 'microshop-api';

// A full-page redirect (e.g. Klarna) wipes the Redux store, so the address/delivery entered
// during checkout must be stashed here beforehand and restored on the payment-return page.
// That includes the shipping option: the server does not store it, and the session was paid at its price.
const STORAGE_KEY = 'cart_payment_return_data';

export type PaymentReturnData = { shippingOptionId: number | undefined } & (
    | { isB2B: true; delivery: Delivery }
    | { isB2B: false; standardCheckout: StandardCheckout }
);

export const savePaymentReturnData = (data: PaymentReturnData): void => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const clearPaymentReturnData = (): void => {
    sessionStorage.removeItem(STORAGE_KEY);
};

export const takePaymentReturnData = (): PaymentReturnData | null => {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    } finally {
        clearPaymentReturnData();
    }
};
